import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { LoginRequest } from 'src/app/models/requests/loginRequest';
import { AuthService } from '../../services/auth/auth.service';
import { DataService } from '../../services/data.service';
import { LocalizationService } from '../../services/localization.service';
import { RoutesList } from 'src/app/models/enums/RoutesList';

@Component({
  selector: 'app-registration-form',
  templateUrl: './registration-form.component.html',
  styleUrls: ['./registration-form.component.scss'],
})
export class RegistrationFormComponent {
  form!: FormGroup;
  isLoading: boolean = false;
  errorMessage = '';
  returnUrl = '';
  anchor = '';
  externalReturnUrl?: string;
  returnParams: any;
  registrationPageData: any
  hidePassword: boolean = true;
  icon: any = {};

  @Input() set portalRegistrationPageData(value: any){
    this.registrationPageData = value;
    if(value){
      this.readReturnPath();
      this.initForm();
      this.getIconItem(this.registrationPageData.icon[0]?.content);
    }
  }

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private dataService: DataService
  ) {}

  getIconItem(data: any) {
    if (!data || !data.icon) return;
    this.icon.image = data.icon.content.umbracoFile.src;
    this.icon.link = data.link.url;
  }
  readReturnPath() {
    this.activatedRoute.queryParams.subscribe((params: any) => {
      this.returnUrl = params['returnUrl'] ?? LocalizationService.getRoute(RoutesList.HomePage);
      this.externalReturnUrl =  params['externalReturnUrl'];
      this.returnParams = params['params']
        ? this.router.parseUrl(params['params']).queryParams
        : null;
      this.anchor = params['anchor'];
    });
  }

  initForm() {
    this.form = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
      //id: ['', [Validators.required,invalidIDValidator()]],
      id: ['', Validators.required],
      keepConnected: [false],
    });
  }

  send() {}
  onSubmit(): void {
    this.isLoading = true;
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.isLoading = false;
      return;
    }

    this.errorMessage = '';
    var loginRequest = <LoginRequest>{};

    loginRequest.cultureCode = this.dataService.getCultureCode();
    loginRequest.userName = this.form.controls['username'].value;
    loginRequest.password = this.form.controls['password'].value;
    loginRequest.id = this.form.controls['id'].value;
    loginRequest.isKeepConnected = this.form.controls['keepConnected'].value;
    loginRequest.returnUrl = this.returnUrl;
    this.authService.login(loginRequest).subscribe(
      (result) => {
        if (result.succeed && result.token) {
          localStorage.setItem(this.authService.tokenKey, result.token);
          if(this.externalReturnUrl)
            window.location.href = this.externalReturnUrl;
          else {
            let navigationObject:NavigationExtras = {
              queryParams: this.returnParams
            }
            if(this.anchor)
              navigationObject.fragment = this.anchor;

            this.router.navigate([this.returnUrl], navigationObject);
          }
        }
        this.isLoading = false;
      },
      (error) => {
        this.errorMessage = error.error.message;
        this.isLoading = false;
      }
    );
  }
}
